import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { mergeStyles } from 'wix-rich-content-common';
import classNames from 'classnames';
import { DEFAULT_HEADERS_DROPDOWN_OPTIONS } from './constants.js';
import { HEADER_TYPE_MAP } from 'wix-rich-content-plugin-commons';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".cvQYx,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.z5I0Q{align-items:flex-start;display:flex;flex-direction:column;width:140px}[dir] .z5I0Q{padding:5px 0}.z5I0Q *{color:var(--ricos-settings-text-color,#333);font-family:var(--ricos-settings-text-font-family,HelveticaNeue,Helvetica,Arial);font-size:14px;height:35px;width:100%}[dir] .z5I0Q *{background-color:transparent;border:none}[dir=ltr] .z5I0Q *{padding-left:18px;text-align:left}[dir=rtl] .z5I0Q *{padding-right:18px;text-align:right}[dir] .z5I0Q :hover{background-color:rgba(var(--ricos-settings-action-color-tuple,0,0,0),.05);cursor:pointer}.agdkv{color:var(--ricos-settings-action-color)}[dir] .agdkv{background-color:rgba(var(--ricos-settings-action-color-tuple,0,0,0),.1)!important}._40nDn{display:grid}[dir] ._40nDn{padding:5px 15px}._40nDn *{flex:1;font-family:var(--ricos-settings-text-font-family,HelveticaNeue,Helvetica,Arial);font-size:16px;height:50px}[dir] ._40nDn *{background-color:transparent;border:none}[dir=ltr] ._40nDn *{text-align:left}[dir=rtl] ._40nDn *{text-align:right}[dir] .TGazl{background:#fff;border:1px solid #ededed;border-radius:var(--ricos-settings-whitebox-border-radius,6px);box-shadow:var(--ricos-settings-whitebox-box-shadow,0 4px 8px 0 rgba(0,0,0,.1),0 0 4px 0 rgba(0,0,0,.1))}[dir] .Sooz8{border:1px solid #ededed;border-radius:unset;box-shadow:0 -4px 8px 0 rgba(0,0,0,.05)}";
var styles = {"fontElementMap":"cvQYx","headingsPanel":"z5I0Q","headingsPanel_selectedHeading":"agdkv","headingsMobilePanel":"_40nDn","headingsPanelContainer":"TGazl","headingsPanelContainer_mobile":"Sooz8"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const headingElement = (heading, isSelected, onClick, translateHeading) => {
  const content = translateHeading(heading);
  const type = HEADER_TYPE_MAP[heading];
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      className: isSelected ? styles.headingsPanel_selectedHeading : "",
      onClick: () => onClick(type, heading)
    },
    content
  );
};
class Panel extends Component {
  render() {
    const { customHeadingsOptions, selected, onSave, styles: styles2, translateHeading, isMobile } = this.props;
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: isMobile ? styles2.headingsMobilePanel : styles2.headingsPanel,
        "data-hook": "headingsDropdownPanel"
      },
      customHeadingsOptions.map((heading) => {
        return headingElement(heading, selected === heading, onSave, translateHeading);
      })
    );
  }
}
class HeadingsDropDownPanel extends Component {
  constructor(props) {
    super(props);
    __publicField(this, "onSaveHeading", (type, headingName) => {
      return this.props.onSave(type, headingName);
    });
    this.state = { heading: props.heading };
    this.styles = mergeStyles({ styles, theme: props.theme });
  }
  render() {
    const {
      isMobile,
      translateHeading,
      customHeadingsOptions = DEFAULT_HEADERS_DROPDOWN_OPTIONS
    } = this.props;
    const { heading } = this.state;
    const { styles: styles2 } = this;
    const selected = heading;
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classNames(styles2.headingsPanelContainer, {
          [styles2.headingsPanelContainer_mobile]: isMobile
        })
      },
      /* @__PURE__ */ React.createElement(
        Panel,
        {
          styles: styles2,
          selected,
          onSave: this.onSaveHeading,
          isMobile,
          translateHeading,
          customHeadingsOptions
        }
      )
    );
  }
}
HeadingsDropDownPanel.propTypes = {
  isMobile: PropTypes.bool,
  onSave: PropTypes.func,
  theme: PropTypes.object.isRequired,
  customSettings: PropTypes.object,
  heading: PropTypes.string,
  translateHeading: PropTypes.func,
  customHeadingsOptions: PropTypes.array
};
HeadingsDropDownPanel.defaultProps = { heading: "P" };
Panel.propTypes = {
  onSave: PropTypes.func,
  selected: PropTypes.any,
  styles: PropTypes.object,
  customHeadingsOptions: PropTypes.array,
  translateHeading: PropTypes.func,
  isMobile: PropTypes.bool
};

export { HeadingsDropDownPanel as H, styleInject as s };
//# sourceMappingURL=HeadingPanel-66005b7c.js.map
